/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum HousingApplicationSource {
    PAPER_APPLICATION = 'PaperApplication',
    SENIOR_APPLICATION = 'SeniorApplication',
    DATA_IMPORT = 'DataImport',
}
